import React from "react"
import classnames from "classnames/bind"
// Style
import quoteStyle from "../../style/components/projects/quote.module.scss"

const Quote = props => {
  return pug`
    div.col-12.my-8(className=classnames(quoteStyle.quote,props.className))
      p.italic(className=props.darkmode?"text-theme-300":"text-gray-300")=props.content
  `
}
export default Quote
